import { render, staticRenderFns } from "./socioFormDocument.vue?vue&type=template&id=7ad3ab95"
import script from "./socioFormDocument.vue?vue&type=script&lang=js"
export * from "./socioFormDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports